import { LabeledToggleButton } from "@theprelude/ds";
import { useExceptedFilters } from "@/queries/control-monitor";

export function ExceptedFilterToggle() {
  const { showExcepted, setShowExcepted } = useExceptedFilters();

  return (
    <LabeledToggleButton
      label="Apply exceptions"
      checked={!showExcepted}
      onChange={(e) => setShowExcepted(!e.target.checked)}
    />
  );
}
